const Immutable = require('immutable');
const resourceSelector = require('./resourceSelector');
const cacheSelector = require('./cacheSelector');
const { resolveResource } = require('./resolve');

const contextMetricsSelector = (state) => {
	const args = state.get('selectedResource','').replace(/^\/+|\/$/g,'').split('/');
	const type = args.length > 0 ? args[0] : 'missing_type';
	const id = args.length > 1 ? args[1] : 'missing_id';
	const props = { type:type, id:id };	
	const cache = cacheSelector(state);
	const resource = resourceSelector(state, props);
	const model = resolveResource(resource, cache, []);
	const contextMetrics = model.get('contextMetrics', Immutable.Map());
	
	

	if(type === 'pages' && id === 'frontpage') {
			return contextMetrics.merge({channel:'Förstasidan', svt_level1:'forstasida', svt_level2:'lop', svt_level3:'index', prop69: 'svtse:svtse:Förstasida:beta'});
	}
	
	if(type === 'pages' && id === 'programs') {
		return contextMetrics.merge({channel:'Program', svt_level1:'program', svt_level2:'lop', svt_level3:'index', prop69: 'svtse:svtse:Förstasida:beta'});
	}

	if(type === 'programs') {
		return contextMetrics.merge({svt_level1:'program', svt_level2:id, svt_level3:'index', prop69: 'svtse:svtse:Förstasida:beta'});
	}

	if(type === 'articles') {
		const program = state.getIn(['router','location','pathname'],'').replace(/(^\/|\/$)/g,'').split('/')[0] || 'program';
		return contextMetrics.merge({svt_level1:'program', svt_level2:program, svt_level3:id, prop69: 'svtse:svtse:Förstasida:beta'});
	}
	return Immutable.Map();
};

module.exports = contextMetricsSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/contextMetricsSelector.js
 **/